import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Button, Center, Flex, Text } from '@chakra-ui/react';

import { ProfileContext } from '../../../core/contexts';
import UserService, { UserClass } from '../../../core/user';
import ProfileService, { ProfileClass } from '../../../core/profile';

export default function PrivacyProfile(): React.ReactElement {
    const { t } = useTranslation();
    const { user, setUser } = useContext(ProfileContext);

    const userService = new UserService();
    const publicUserService = new ProfileService();

    const [isSaving, setIsSaving] = useState(false);

    const setProfile = async (state: boolean) => {
        setIsSaving(true);
        user.public = state;
        const saved = await userService.save(user);
        setUser(saved as UserClass);
        publicUserService.save(new ProfileClass(saved));
        setIsSaving(false);
    };

    return (
        <Alert status='info' mt={6} variant='left-accent' size={'xs'}>
            <Flex direction='column'>
                {user.public ? (
                    <>
                        <Text> {t('shareModal.privateProfileInfo')}</Text>
                        <Text> {t('shareModal.privateProfileInfo2')}</Text>
                    </>
                ) : (
                    <>
                        <Text> {t('shareModal.publicProfileInfo')}</Text>
                        <Text> {t('shareModal.publicProfileInfo2')}</Text>
                    </>
                )}

                <Center>
                    {user.public ? (
                        <Button
                            size='md'
                            my='4'
                            colorScheme='blue'
                            backgroundColor={'white'}
                            variant='outline'
                            onClick={() => setProfile(false)}
                        >
                            {t('shareModal.privateProfileButton')}
                        </Button>
                    ) : (
                        <Button
                            size='md'
                            my='4'
                            colorScheme='blue'
                            backgroundColor={'white'}
                            variant='outline'
                            onClick={() => setProfile(true)}
                            isLoading={isSaving}
                        >
                            {t('shareModal.publicProfileButton')}
                        </Button>
                    )}
                </Center>
            </Flex>
        </Alert>
    );
}
